import { render, staticRenderFns } from "./ParcelOutBound.vue?vue&type=template&id=4e9677db&scoped=true"
import script from "./ParcelOutBound.vue?vue&type=script&lang=js"
export * from "./ParcelOutBound.vue?vue&type=script&lang=js"
import style0 from "./ParcelOutBound.vue?vue&type=style&index=0&id=4e9677db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9677db",
  null
  
)

export default component.exports